module.exports = __webpack_public_path__ + "static/img/delete_booking.e247ed16.svg";